import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import { renderMarkdown } from "../../../utils/markdownRenderer";
import { MARKDOWN_PROSE_SX } from "../../../utils/markdownProseSx";
import { FONT, INK_SECONDARY } from "../../../theme/tokens";

// Drop Hugging Face YAML frontmatter before rendering the model card body.
function cleanModelCardMarkdown(content) {
  return String(content || "")
    .replace(/^---[\s\S]*?---/, "")
    .trim();
}

export default function ModelCardMarkdownPreview({ content }) {
  const cleaned = cleanModelCardMarkdown(content);

  if (!cleaned) {
    return (
      <Typography sx={{ fontSize: FONT.sm, color: INK_SECONDARY }}>
        No cached model card is available yet.
      </Typography>
    );
  }

  return (
    <Box
      sx={[
        MARKDOWN_PROSE_SX,
        {
          // Drawer-sized markdown: quieter text, compact headings, scrolling
          // tables, and hidden images.
          color: INK_SECONDARY,
          fontSize: FONT.sm,
          lineHeight: 1.6,
          "& h1, & h2, & h3": { fontSize: FONT.md, mt: 1.25, mb: 0.5 },
          "& p": { my: 0.75 },
          "& ul, & ol": { pl: 2.5, my: 0.75 },
          "& li": { my: 0.25 },
          "& code": { fontSize: FONT.xs },
          "& pre": { p: 1, my: 1, maxHeight: 180 },
          "& blockquote": { pl: 1.5, my: 0.75 },
          "& table": {
            display: "block",
            maxWidth: "100%",
            overflowX: "auto",
            my: 1,
            fontSize: FONT.xs,
          },
          "& th, & td": { px: 1, py: 0.5 },
          "& hr": { my: 1.25 },
          "& img": { display: "none" },
        },
      ]}
      dangerouslySetInnerHTML={{ __html: renderMarkdown(cleaned) }}
    />
  );
}

ModelCardMarkdownPreview.propTypes = {
  content: PropTypes.string,
};
